(function() {
  'use strict';

  var dataEl = document.getElementById('configurator-product-data');
  if (!dataEl) return;

  var productData = JSON.parse(dataEl.textContent);
  var variants = productData.variants;
  var optionsCount = productData.options_count;

  // State
  var state = {
    step: 1,
    maxStepReached: 1,
    size: null,
    design: null,
    designImage: null,
    nombre: '',
    mensaje: '',
    variantId: null,
    price: null,
    priceFormatted: null,
    photos: [] // { file: File, preview: dataURL }
  };

  var MAX_PHOTOS = 3;
  var MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  // DOM refs
  var panels = document.querySelectorAll('.configurator__panel');
  var indicators = document.querySelectorAll('.configurator__step-indicator');
  var nextBtns = document.querySelectorAll('.configurator__btn--next');
  var prevBtns = document.querySelectorAll('.configurator__btn--prev');
  var addToCartBtn = document.getElementById('cfg-add-to-cart');
  var charCount = document.getElementById('cfg-char-count');
  var textarea = document.getElementById('cfg-dedicatoria-texto');
  var nombreInput = document.getElementById('cfg-dedicatoria-nombre');
  var heroImg = document.getElementById('cfg-hero-img');
  var headerPrice = document.getElementById('cfg-header-price');
  var photoInput = document.getElementById('cfg-photo-input');
  var photoGrid = document.getElementById('cfg-photo-grid');
  var photoAddBtn = document.getElementById('cfg-photo-add-btn');

  // Terminación removed — products use single option (size only)

  // ==================== AUTO-SELECT FIRST SIZE ====================

  var sizeRadios = document.querySelectorAll('input[name="cfg-size"]');
  if (sizeRadios.length > 0) {
    sizeRadios[0].checked = true;
    state.size = sizeRadios[0].value;
    state.price = parseInt(sizeRadios[0].dataset.price);
    updateVariant();
    updateHeaderPrice();
    enableNext(1);
  }

  // ==================== NAVIGATION ====================

  function goToStep(step) {
    state.step = step;
    if (step > state.maxStepReached) state.maxStepReached = step;

    panels.forEach(function(p) {
      p.classList.toggle('active', parseInt(p.dataset.panel) === step);
    });

    indicators.forEach(function(ind) {
      var s = parseInt(ind.dataset.step);
      ind.classList.toggle('active', s === step);
      ind.classList.toggle('completed', s < step);
      ind.style.cursor = (s <= state.maxStepReached && s !== step) ? 'pointer' : 'default';
    });

    setTimeout(function() {
      var activePanel = document.querySelector('.configurator__panel.active');
      var progressBar = document.querySelector('.configurator__progress');
      if (progressBar) {
        var offset = progressBar.getBoundingClientRect().height + 10;
        var panelTop = activePanel ? activePanel.getBoundingClientRect().top + window.pageYOffset - offset - 10 : 0;
        var progressTop = progressBar.getBoundingClientRect().top + window.pageYOffset;
        var scrollTarget = Math.min(progressTop, panelTop);
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
    }, 50);

    if (step === 4) {
      populateSummary();
    }
  }

  nextBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      goToStep(parseInt(this.dataset.next));
    });
  });

  prevBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      goToStep(parseInt(this.dataset.prev));
    });
  });

  // ==================== STEP 1: SIZE ====================

  sizeRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      state.size = this.value;
      state.price = parseInt(this.dataset.price);
      updateVariant();
      updateHeaderPrice();
      enableNext(1);
    });
  });

  // ==================== STEP 2: DESIGN ====================

  var designRadios = document.querySelectorAll('input[name="cfg-design"]');
  designRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      state.design = this.value;
      state.designImage = this.dataset.image;

      if (heroImg && state.designImage) {
        heroImg.src = state.designImage;
        heroImg.alt = state.design;
        heroImg.classList.add('configurator__hero-img--updated');
      }

      enableNext(2);
    });
  });

  // ==================== STEP 3: DEDICATORIA ====================

  if (nombreInput) {
    nombreInput.addEventListener('input', function() {
      state.nombre = this.value;
    });
  }

  if (textarea) {
    textarea.addEventListener('input', function() {
      state.mensaje = this.value;
      if (charCount) {
        charCount.textContent = this.value.length;
      }
    });
  }

  // ==================== PHOTO UPLOAD ====================

  if (photoInput) {
    photoInput.addEventListener('change', function() {
      var files = Array.from(this.files);
      var remaining = MAX_PHOTOS - state.photos.length;

      if (remaining <= 0) {
        alert('Ya agregaste el máximo de ' + MAX_PHOTOS + ' fotos.');
        this.value = '';
        return;
      }

      var toAdd = files.slice(0, remaining);

      toAdd.forEach(function(file) {
        if (file.size > MAX_FILE_SIZE) {
          alert('"' + file.name + '" es demasiado grande. Máximo 5 MB por foto.');
          return;
        }

        if (!file.type.startsWith('image/')) {
          alert('"' + file.name + '" no es una imagen válida.');
          return;
        }

        var reader = new FileReader();
        reader.onload = function(e) {
          state.photos.push({ file: file, preview: e.target.result, name: file.name });
          renderPhotoPreviews();
        };
        reader.readAsDataURL(file);
      });

      // Reset input so same file can be re-selected
      this.value = '';
    });
  }

  function renderPhotoPreviews() {
    // Remove existing previews
    var existing = photoGrid.querySelectorAll('.configurator__photo-preview');
    existing.forEach(function(el) { el.remove(); });

    // Add previews before the add button
    state.photos.forEach(function(photo, index) {
      var div = document.createElement('div');
      div.className = 'configurator__photo-preview';
      div.innerHTML = '<img src="' + photo.preview + '" alt="Foto ' + (index + 1) + '">' +
        '<button type="button" class="configurator__photo-remove" data-index="' + index + '">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>';
      photoGrid.insertBefore(div, photoAddBtn);
    });

    // Hide add button if max reached
    if (state.photos.length >= MAX_PHOTOS) {
      photoAddBtn.style.display = 'none';
    } else {
      photoAddBtn.style.display = '';
    }

    // Bind remove buttons
    photoGrid.querySelectorAll('.configurator__photo-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.dataset.index);
        state.photos.splice(idx, 1);
        renderPhotoPreviews();
      });
    });
  }

  // ==================== VARIANT MATCHING ====================

  function updateVariant() {
    if (!state.size) return;

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === state.size) {
        match = variants[i];
        break;
      }
    }

    if (match) {
      state.variantId = match.id;
      state.price = match.price;
      state.priceFormatted = match.price_formatted;
    }
  }

  // ==================== UPDATE HEADER PRICE ====================

  function updateHeaderPrice() {
    if (headerPrice && state.priceFormatted) {
      headerPrice.textContent = state.priceFormatted;
      headerPrice.classList.add('configurator__price-amount--flash');
      setTimeout(function() {
        headerPrice.classList.remove('configurator__price-amount--flash');
      }, 400);
    }
  }

  // ==================== ENABLE/DISABLE NEXT ====================

  function enableNext(step) {
    var panel = document.querySelector('[data-panel="' + step + '"]');
    if (!panel) return;
    var nextBtn = panel.querySelector('.configurator__btn--next');
    if (nextBtn) {
      nextBtn.disabled = false;
    }
  }

  // ==================== SUMMARY ====================

  function populateSummary() {
    updateVariant();

    document.getElementById('cfg-summary-size').textContent = state.size || '-';
    document.getElementById('cfg-summary-design').textContent = state.design || '-';
    document.getElementById('cfg-summary-price').textContent = state.priceFormatted || '-';

    var nameRow = document.getElementById('cfg-summary-name-row');
    var msgRow = document.getElementById('cfg-summary-message-row');
    var photosRow = document.getElementById('cfg-summary-photos-row');

    if (state.nombre) {
      nameRow.style.display = '';
      document.getElementById('cfg-summary-name').textContent = state.nombre;
    } else {
      nameRow.style.display = 'none';
    }

    if (state.mensaje) {
      msgRow.style.display = '';
      document.getElementById('cfg-summary-message').textContent = state.mensaje;
    } else {
      msgRow.style.display = 'none';
    }

    if (state.photos.length > 0) {
      photosRow.style.display = '';
      document.getElementById('cfg-summary-photos').textContent = state.photos.length + (state.photos.length === 1 ? ' foto adjunta' : ' fotos adjuntas');
    } else {
      photosRow.style.display = 'none';
    }

    var summaryImg = document.getElementById('cfg-summary-image');
    if (state.designImage) {
      summaryImg.src = state.designImage;
      summaryImg.alt = state.design || 'Diseño seleccionado';
      summaryImg.style.display = '';
    } else {
      summaryImg.style.display = 'none';
    }
  }

  // ==================== ADD TO CART ====================

  /* Telemetría local — accesible vía window.tematikDiag() en consola.
     Guarda los últimos eventos en localStorage para que soporte pueda pedir al
     cliente que abra la consola del navegador y los copie. */
  function logDiag(event, data) {
    try {
      var entry = { ts: new Date().toISOString(), event: event, data: data };
      console.log('[CART-DIAG]', event, data || '');
      var hist = JSON.parse(localStorage.getItem('cart_diag') || '[]');
      hist.push(entry);
      if (hist.length > 50) hist = hist.slice(-50);
      localStorage.setItem('cart_diag', JSON.stringify(hist));
    } catch (e) { /* swallow */ }
  }
  window.tematikDiag = function() {
    try { return JSON.parse(localStorage.getItem('cart_diag') || '[]'); }
    catch (e) { return []; }
  };

  /* Comprime una imagen via canvas: redimensiona a maxDim y exporta JPEG quality.
     Si el navegador no puede o el resultado es mayor que el original, devuelve el original. */
  function compressImage(file, maxDim, quality) {
    return new Promise(function(resolve) {
      try {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function() {
          URL.revokeObjectURL(url);
          var w = img.naturalWidth, h = img.naturalHeight;
          var scale = Math.min(1, maxDim / Math.max(w, h));
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var canvas = document.createElement('canvas');
          canvas.width = cw; canvas.height = ch;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, cw, ch);
          canvas.toBlob(function(blob) {
            if (!blob || blob.size >= file.size) return resolve(file);
            var name = (file.name || 'foto').replace(/\.[a-z0-9]+$/i, '') + '.jpg';
            resolve(new File([blob], name, { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        img.onerror = function() { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      } catch (e) { resolve(file); }
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      if (!state.variantId) {
        logDiag('no-variant', { size: state.size });
        alert('Error: no se pudo determinar la variante. Volvé a seleccionar la medida.');
        return;
      }

      this.disabled = true;
      this.textContent = 'Agregando...';

      logDiag('cart-add-start', {
        variantId: state.variantId,
        size: state.size,
        design: state.design,
        photos: state.photos.length,
        photo_sizes: state.photos.map(function(p) { return p.file.size; })
      });

      if (state.photos.length > 0) {
        addToCartWithFiles();
      } else {
        addToCartJSON();
      }
    });
  }

  function addToCartJSON() {
    var properties = {};
    if (state.design) properties['Diseño'] = state.design;
    if (state.nombre) properties['Nombre'] = state.nombre;
    if (state.mensaje) properties['Mensaje'] = state.mensaje;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: state.variantId, quantity: 1, properties: properties }] })
    })
    .then(function(response) {
      return response.json().catch(function() { return null; }).then(function(body) {
        return { ok: response.ok, status: response.status, body: body };
      });
    })
    .then(function(r) {
      if (!r.ok) {
        var msg = (r.body && (r.body.description || r.body.message)) || ('HTTP ' + r.status);
        logDiag('cart-add-fail', { mode: 'json', status: r.status, body: r.body });
        throw new Error(msg);
      }
      logDiag('cart-add-ok', { mode: 'json' });
      window.location.href = '/cart';
    })
    .catch(handleCartError);
  }

  function addToCartWithFiles() {
    Promise.all(state.photos.map(function(p) {
      return compressImage(p.file, 1600, 0.85);
    })).then(function(compressed) {
      var formData = new FormData();
      formData.append('id', state.variantId);
      formData.append('quantity', 1);
      if (state.design) formData.append('properties[Diseño]', state.design);
      if (state.nombre) formData.append('properties[Nombre]', state.nombre);
      if (state.mensaje) formData.append('properties[Mensaje]', state.mensaje);

      var sizeReport = [];
      compressed.forEach(function(blob, i) {
        formData.append('properties[Foto ' + (i + 1) + ']', blob, blob.name);
        sizeReport.push({ idx: i + 1, before: state.photos[i].file.size, after: blob.size });
      });
      logDiag('photos-compressed', sizeReport);

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
    })
    .then(function(response) {
      return response.json().catch(function() { return null; }).then(function(body) {
        return { ok: response.ok, status: response.status, body: body };
      });
    })
    .then(function(r) {
      if (!r.ok) {
        var msg = (r.body && (r.body.description || r.body.message)) || ('HTTP ' + r.status);
        logDiag('cart-add-fail', { mode: 'files', status: r.status, body: r.body });
        throw new Error(msg);
      }
      logDiag('cart-add-ok', { mode: 'files' });
      window.location.href = '/cart';
    })
    .catch(handleCartError);
  }

  function handleCartError(err) {
    var detail = err && err.message ? ' (' + err.message + ')' : '';
    alert('No pudimos agregar al carrito' + detail + '. Probá de nuevo o escribínos por WhatsApp.');
    addToCartBtn.disabled = false;
    addToCartBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Agregar al carrito';
    logDiag('cart-handle-error', { msg: err && err.message });
    console.error('[CART-DIAG] error', err);
  }

  // ==================== CLICKABLE STEP INDICATORS ====================

  indicators.forEach(function(ind) {
    ind.addEventListener('click', function() {
      var targetStep = parseInt(this.dataset.step);
      if (targetStep <= state.maxStepReached && targetStep !== state.step) {
        goToStep(targetStep);
      }
    });
  });

})();
